module.exports = __webpack_public_path__ + "images/emoji/cry.c8d9a9c9c6ca87820597.png";